export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8052.fd81b49e.jpg";